import { DataLoader } from '../loadData';
import { roleLoader } from './roleLoader';
import { accountLoader } from './accountLoader';

export const accountAndRoleLoader: DataLoader = (state, dispatch, auth) =>
  accountLoader(state, dispatch, auth) && roleLoader(state, dispatch, auth);

export default accountAndRoleLoader;
